module.exports = "/images/vendor/flag-icon-css/flags/4x3/ie.svg?c68ff961baf04c04f9beac2c32cd2458";